(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerListCard', {
            templateUrl: 'app/components/flyer-list-card/flyer-list-card.html',
            controller: flyerListCardController,
            bindings: {
                flyer: '<',
                bucket: '=',
                checkboxIsChecked: '<',
                checkboxClick: '&',
                isPublished: '<',
                currencyInstance: '<',
                isRealStateMarket: '=',
                unpublishFlyer: '&',
                publishFlyer: '&',
                flyerActions: '<',
                flyerMethods: '<',
                isHubContext: '=',
                isShowCaseContext: '=',
                isOnShowCase: '<',
                erpIcon: '<'
            }
        });

    /** @ngInject */
    function flyerListCardController($rootScope, $scope, $document, $translate, toastr, $window, flyersConstants, systemConstants) {

        var $ctrl = this;

        $ctrl.$onInit = init;

        function init() {
            $ctrl.dateFormat = $translate.instant('dateFormat');

            if ($ctrl.flyerMethods) {
                $ctrl.accessHotsite = $ctrl.flyerMethods.get(flyersConstants.FLYER_ACTION.HOTSITE);
                $ctrl.copyLink = $ctrl.flyerMethods.get(flyersConstants.FLYER_ACTION.LINK);
                $ctrl.shareWhatsapp = $ctrl.flyerMethods.get(flyersConstants.FLYER_ACTION.SEND);
            }

            var coverImageResolution = systemConstants.IMAGE_RESOLUTIONS.LIST_CARD;
            var groupedImage = getGroupedCoverImage($ctrl.flyer);

            if (groupedImage) {
                $ctrl.coverImage = groupedImage;
            } else {
                $ctrl.coverImage = $ctrl.isHubContext ?
                    getHubFlyerImageWithResolution($ctrl.flyer, coverImageResolution)
                    : getFlyerImageWithResolution($ctrl.flyer, coverImageResolution);
            }
        }
    }
})();
